var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLayoutList = function SvgLayoutList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 1,
    rx: 1.5,
    height: 3,
    width: 13,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    rx: 1.5,
    height: 3,
    width: 13,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 17,
    rx: 1.5,
    height: 3,
    width: 13,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    rx: 2,
    height: 5,
    width: 5,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8,
    rx: 2,
    height: 5,
    width: 5,
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16,
    rx: 2,
    height: 5,
    width: 5,
    fill: "currentColor"
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogIDxyZWN0IHg9IjgiIHk9IjEiIHJ4PSIxLjUiIGhlaWdodD0iMyIgd2lkdGg9IjEzIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4NCiAgPHJlY3QgeD0iOCIgeT0iOSIgcng9IjEuNSIgaGVpZ2h0PSIzIiB3aWR0aD0iMTMiIGZpbGw9ImN1cnJlbnRDb2xvciIvPg0KICA8cmVjdCB4PSI4IiB5PSIxNyIgcng9IjEuNSIgaGVpZ2h0PSIzIiB3aWR0aD0iMTMiIGZpbGw9ImN1cnJlbnRDb2xvciIvPg0KICA8cmVjdCB4PSIwIiB5PSIwIiByeD0iMiIgaGVpZ2h0PSI1IiB3aWR0aD0iNSIgZmlsbD0iY3VycmVudENvbG9yIi8+DQogIDxyZWN0IHg9IjAiIHk9IjgiIHJ4PSIyIiBoZWlnaHQ9IjUiIHdpZHRoPSI1IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4NCiAgPHJlY3QgeD0iMCIgeT0iMTYiIHJ4PSIyIiBoZWlnaHQ9IjUiIHdpZHRoPSI1IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4NCjwvc3ZnPg0K";
export { SvgLayoutList as ReactComponent };